/** Pull the real names Phase 2's commands are personalized with. */
export interface Personalization { topName: string; topFirst: string; secondFirst: string; project: string }

const first = (full: unknown): string => String(full ?? '').trim().split(/\s+/)[0] ?? '';

export function pickPersonalization(
  contacts: Array<Record<string, unknown>>,
  bundle: { company?: string },
): Personalization {
  const ranked = [...contacts].sort(
    (a, b) => Number(b.emailCount ?? 0) - Number(a.emailCount ?? 0),
  );
  const top = ranked[0];
  const second = ranked[1];
  const topName = top ? String(top.name ?? top.title ?? '') : '';
  return {
    topName,
    topFirst: top ? first(topName) || 'your top contact' : 'your top contact',
    secondFirst: second ? first(second.name ?? second.title) || 'a contact' : 'a contact',
    project: (bundle.company ?? '').trim() || 'your work',
  };
}

/**
 * Vendor/service mailbox detector — keeps support desks, hotels, payment
 * processors, and no-reply senders out of "Your people" and the personalized
 * commands. Matches the email local-part and service-y display names.
 */
const SERVICE_LOCALPART = /^(support|no-?reply|noreply|donotreply|info|hello|help|team|billing|sales|contact|notifications?|service|services|admin|newsletter|news|updates|alerts|marketing|reservations?|reception|bookings?|orders?|receipts?|store|shop|accounts?|security|care|customerservice|feedback|press|media|jobs|careers|invoices?|payments?)$/i;
const SERVICE_NAME = /\b(support|team|reception|service|billing|no.?reply|notifications?|customer|newsletter|booking|reservations?)\b|^contact\b/i;

export function isServiceContact(name: unknown, email: unknown): boolean {
  const local = String(email ?? '').split('@')[0]?.trim() ?? '';
  if (local && SERVICE_LOCALPART.test(local)) return true;
  return SERVICE_NAME.test(String(name ?? '').trim());
}
